<template>
    <div class="subscriptions">
        <div :class="{ shadow: scrolled }" class="header">
            <div class="search">
                <Search class="input"
                        placeholder="Поиск по продуктам"
                        @search="onInputQuery" />
            </div>
        </div>
        <InfinityScroll ref="scroll" :load-next="loadNextPage" class="scroll" root=".subscriptions">
            <template v-if="!notFound">
                <CardSubscription v-for="it in elements"
                                  :key="it.id"
                                  :productTypesMap="productTypesMap"
                                  :value="it"
                                  @closeModal="close"
                                  @unsubscribing="beforeUnsubscribing" />
            </template>

            <div v-else-if="notAdded" class="no-elements">
                <div class="icon"></div>
                <div class="text">Подписки ещё не добавлены</div>
            </div>

            <div v-else class="not-found">
                <div class="title">Ничего не найдено</div>
                <div class="desc">
                    Нет ни одного совпадения по запросу.<br>
                    Измените критерии поиска.
                </div>
            </div>

            <template #loader>
                <CardNewsSkeleton v-for="it in 5" :key="it" class="card-skeleton" />
            </template>
        </InfinityScroll>
    </div>
</template>

<script>
import { favoriteUnsub } from '@/common/page_comp/Favorite/util';
import CardNewsSkeleton from '@/common/skeletons/CardNewsSkeleton.vue';
import { unsubscribing } from '@/common/page_comp/News/SubTab/common/util.js';
import Search from '@/common/comp/search/Search.vue';
import { toMap } from '@dsee/util/arrays.js';
import { search } from '@/restapi/news/news.subscription.js';
import { loadDicts } from '@/restapi/product/product.js';
import CardSubscription from './CardSubscription.vue';

export default {
    name: 'SubscriptionsList',
    components: {
        CardNewsSkeleton,
        CardSubscription,
        Search,
    },
    props: {
        showConfirm: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            model: {
                query: '',
            },

            elements: [],
            load: false,

            reqtId: 0,

            scrolled: false,

            dicts: {
                productTypes: [],
            },
        };
    },
    computed: {
        notFound() {
            return this.elements.length === 0 && !this.load;
        },
        notAdded() {
            return this.notFound && !this.model.query.length && !this.load;
        },
        hasNext() {
            return this.reqtId === 0;
        },
        productTypesMap() {
            return toMap(this.dicts.productTypes);
        },
    },
    async created() {
        this.dicts.productTypes = (await loadDicts()).productTypes;
        this.$options.unwatch = this.$watch((vm) => [ vm.model.query ], this.resetSearch);
    },
    destroyed() {
        this.$options.unwatch();
        document.removeEventListener('scroll', this.onScroll, true);
    },
    mounted() {
        document.addEventListener('scroll', this.onScroll, true);
    },
    methods: {
        async loadNextPage() {
            if (!this.hasNext)
                return false;

            this.load = true;
            const reqtId = ++this.reqtId;

            const reqt = {
                limit: 99999,
                offset: 0,
                ...this.model,
            };

            try {
                const resp = await search(reqt);

                if (reqtId !== this.reqtId)
                    return;

                this.elements = this.elements.concat(resp);
                return true;
            } catch (e) {
                console.warn(e);
            } finally {
                this.load = false;
            }
        },
        onScroll() {
            this.scrolled = !!this.$refs.scroll.$el.scrollTop;
        },
        resetSearch() {
            this.elements.splice(0);
            this.reqtId = 0;
            this.$refs.scroll.restart();
        },
        onInputQuery(query) {
            this.model.query = query;
        },
        async unsubscribing(product) {
            try {
                await favoriteUnsub(product.id);
                this.$emit('updateNews');
            } catch (e) {
                console.warn(e);
            }

            this.resetSearch();
        },
        async beforeUnsubscribing(item) {
            const resp = await this.showConfirm({
                title: `Вы уверены, что хотите отписаться от обновлений по «${ item.name }»?`,
                text: '',
                accept: 'Да',
                cancel: 'Отмена',
            });

            if (!resp)
                return;

            this.unsubscribing(item);
        },
        close() {
            this.$emit('closeModal');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.subscriptions {
    padding-top: 32px;
    box-sizing: border-box;
    overflow-x: auto;
    position: relative;
    @include scrollbar;

    .header {
        padding: 0 32px;
        margin-bottom: 20px;

        &.shadow {
            box-shadow: 0px 4px 8px rgba(28, 41, 61, 0.1);
        }
    }

    .filter {
        display: flex;
        margin-top: 18px;
        justify-content: space-between;
        padding-bottom: 20px;
    }

    .no-elements {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 24px 0 32px;
        margin: 0 32px;
        border-radius: 4px;
        border: 1px solid rgba(16, 24, 40, 0.10);

        .icon {
            @include icon(100px, 100px);
            cursor: default;
            background-image: url('./icons/notFound.png');
            margin-bottom: 16px;
        }

        .text {
            font-weight: 500;
        }
    }

    .not-found {
        text-align: center;
        margin-top: 10%;

        .title {
            color: #000000;
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 12px;
            font-weight: bold;
        }

        .desc {
            font-size: 14px;
            line-height: 20px;
        }
    }

    .card-skeleton {
        padding-left: 24px;
        padding-right: 24px;
    }
}
</style>
